import React from 'react';

export default function ToggleButtonIntConv(props) {
  return (
    <div className="toggle-container">
      <input
        type="radio"
        id="in"
        name="radio"
        onChange={props.handleToggleInchCM}
        className="checkbox"
        checked={props.inches}
      />
      <label
        className={`toggle-container__in ${props.inches ? 'active' : 'inactive'}`}
        htmlFor="in"
      >
        in
      </label>

      <input
        type="radio"
        id="cm"
        name="radio"
        onChange={props.handleToggleInchCM}
        className="checkbox"
        checked={!props.inches}
      />
      <label
        className={`toggle-container__cm ${props.inches ? 'inactive' : 'active'}`}
        htmlFor="cm"
      >
        cm
      </label>
    </div>
  );
}
